import { createStorage } from 'vuex-localstorage'
import UserService from '@/services/user'
// import Vue from 'vue'
import http from '@/libs/http'

const USER_KEY = 'user'
const persist = createStorage({
  namespace: USER_KEY,
  initialState: {
    authenticated: false,
    role: null,
    userId: null,
    token: null,
    data: null,
    position: null
  }
})
// initial state
const state = {
  authenticated: persist.get().authenticated,
  role: persist.get().role,
  userId: persist.get().userId,
  token: persist.get().token,
  data: persist.get().data,
  position: persist.get().position
}

const getters = {
  getUser: state => state,
  isAuthenticated: state => state.authenticated,
  fullname: state => {
    console.log('state', state)
    return (state.data) ? `${state.data.firstname} ${state.data.lastname}` : ''
  },
  token: state => state.token
}

const JWT_ITEM_KEY = process.env.VUE_APP_JWT_ITEM
const TOKEN_ITEM_KEY = process.env.VUE_APP_TOKEN_ITEM

// mutations
const mutations = {
  signin(state, value) {
    const userState = {}
    userState.authenticated = true
    userState.data = value
    Object.assign(state, userState)
    persist.set(userState)
  },
  signout(state) {
    const userState = {
      authenticated: false
    }
    Object.assign(state, userState)
    persist.set(userState)
  },
  login(state, value) {
    const userState = {}
    userState.authenticated = true
    userState.token = value.token
    userState.data = value.data
    Object.assign(state, userState)
    persist.set(userState)
    http.defaults.headers.common['token'] = value.token
  },
  logout(state) {
    const userState = {
      authenticated: false,
      token: null
    }
    http.defaults.headers.common['token'] = ''
    Object.assign(state, userState)
    persist.set(userState)
  }
}

const actions = {
  signin({ commit, state }, credentials) {
    return UserService.signin(credentials).then((user) => {
      commit('signin', user)
    })
  },
  signout({ commit, state }) {
    commit('signout')
  },
  login({ commit, state }, { email, password }) {
    return UserService.login({ email, password }).then(({ code, result }) => {
      if (code === 200) {
        const expire = new Date(Date.now() + (60 * 60 * 1000)).toString()
        localStorage.setItem(JWT_ITEM_KEY, result.token)
        localStorage.setItem(TOKEN_ITEM_KEY, JSON.stringify({
          expire,
          value: {
            authenticated: true,
            data: result.data,
            token: result.token
          }
        }))
      }
      commit('login', result)
    }).catch((err) => {
      commit('login', null)
      localStorage.removeItem(JWT_ITEM_KEY)
      localStorage.removeItem(TOKEN_ITEM_KEY)
    })
  },
  logout({ commit, state }, credentials) {
    localStorage.removeItem(JWT_ITEM_KEY)
    localStorage.removeItem(TOKEN_ITEM_KEY)
    return UserService.logout().then((res) => {
      commit('logout')
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
